import { render, staticRenderFns } from "./zj-section-title.vue?vue&type=template&id=1e97efd3&"
import script from "./zj-section-title.vue?vue&type=script&lang=js&"
export * from "./zj-section-title.vue?vue&type=script&lang=js&"
import style0 from "./zj-section-title.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports